import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();
const SUPPORTED_IMAGE_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/webp",
];
const branchValidationForm = yup.object({
  name: yup.string().required("Name is required"),
  company_name: yup.string().required("Company Name is required"),
  primary_email: yup.string().email().required("Primary Email is required"),
  secondary_contact: yup
    .string()
    .transform((value) => {
      if (!value || value.trim() === "+977") {
        return null;
      }
      return value;
    })
    .nullable()
    .notRequired()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Primary contact is required"),
  manager: yup.string().required("Branch manager is required"),
  landmark: yup.string().required("Landmark is required"),
  warehouse: yup.string().optional().nullable(),
  vat_pan: yup.string().required("VAT/PAN is required"),
  code: yup.string().required("Code is required"),
  is_franchise: yup.boolean().optional().nullable(),
  is_enable_sms: yup.boolean().optional().nullable(),
  is_enable_email: yup.boolean().optional().nullable(),
  is_active: yup.boolean().optional().nullable(),
  charge_type: yup
    .string()
    .oneOf(
      ["percentage", "flat"],
      "Charge type must be either 'percentage' or 'flat'"
    )
    .required("Charge Type is required"),
  charge: yup
    .string()
    .nullable()
    .transform((value) => (value ? value : "0"))
    .test("is-valid-charge", function (value) {
      const { charge_type } = this.parent;
      const chargeValue = Number(value);
      if (charge_type === "percentage") {
        if (chargeValue < 0 || chargeValue > 100) {
          return this.createError({
            message: "Charge must be between 0 and 100 for percentage type.",
          });
        }
      }
      return true; // For "flat", no specific validation is applied.
    }),
  transit_charge: yup
    .string()
    .transform((value) => (value ? value : "0"))
    .nullable(),
});
let bankDetailsValidationForm = yup.object().shape({
  beneficiary: yup.string().required("Name is required"),
  bank_name: yup.string().required("Bank Name is required"),
  account_number: yup.string().required("Account No. is required"),
  address: yup.string().required("Address is required"),
  code: yup.string().required("Swift Code is required"),
});
let createBranchServiceValidationForm = yup.object().shape({
  code: yup
    .string()
    .required("Code is required")
    .min(3, "Code must be at least 3 characters")
    .max(20, "Code must be at most 20 characters")
    .notOneOf(["admin", "root", "superuser"], "This username is not allowed"),
  name: yup.string().required("Full Name is required"),
  primary_email: yup.string().email().required("Email is required"),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Primary contact is required"),
  vat_pan: yup.string().required("VAT/PAN is required"),
});

export { branchValidationForm, bankDetailsValidationForm, createBranchServiceValidationForm };
